<template>
  <vue-editor ref="rte" v-bind="attrs" :disabled="disabled" v-on="$listeners" />
</template>

<script>
import { VueEditor } from 'vue2-editor';
export default {
  components: {
    VueEditor
  },
  props: {
    useDefaultToolbar: Boolean,
    disabled: Boolean
  },
  computed: {
    quill() {
      return this.$refs.rte.quill;
    },
    attrs() {
      const _attrs = { ...this.$attrs };
      if (!this.useDefaultToolbar) {
        _attrs.editorToolbar = [
          ['bold', 'italic', 'underline', 'strike'],
          [{ color: [] }, { background: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['image', 'link']
        ];
      }
      return _attrs;
    }
  },
  methods: {
    focus() {
      this.$nextTick(() => {
        if (!this.disabled) {
          this.$refs.rte.quill.enable();
        }
        this.$refs.rte.quill.focus();
      });
    }
  }
};
</script>
